import { Component, OnInit } from "@angular/core";
import { iM } from "@angular/core/src/render3";

@Component({
  selector: "app-maintenance-note-number",
  templateUrl: "./maintenance-note-number.component.html",
  styleUrls: ["./maintenance-note-number.component.css"],
})
export class MaintenanceNoteNumberComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
